import config from "config/config";
export async function resetPassword(userId, password) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      UserId: userId,
      NewPassword: password,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/resetpassword",
    options
  );

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
